import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { TypeIcon, ImageIcon, SparklesIcon, DownloadIcon, InstagramIcon, FacebookIcon } from 'lucide-react';
export function PostComposerPage() {
  const [selectedTemplate, setSelectedTemplate] = useState(0);
  const [caption, setCaption] = useState('Fall is here! ☕🍂 Try our new Pumpkin Spice Latte made with real pumpkin and organic spices.');
  const templates = [{
    name: 'Instagram Story',
    size: '1080x1920'
  }, {
    name: 'Instagram Post',
    size: '1080x1080'
  }, {
    name: 'Facebook Post',
    size: '1200x630'
  }, {
    name: 'LinkedIn Post',
    size: '1200x627'
  }];
  return <div className="h-full flex" data-id="element-219">
      <div className="flex-1 bg-gray-100 dark:bg-gray-950 p-6 flex items-center justify-center" data-id="element-220">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl overflow-hidden" style={{
        width: 400,
        height: 600
      }} data-id="element-221">
          <div className="h-full bg-gradient-to-br from-orange-400 via-pink-400 to-purple-500 relative flex items-center justify-center" data-id="element-222">
            <div className="absolute inset-0 bg-black/30" data-id="element-223" />
            <div className="relative z-10 p-8 text-white text-center" data-id="element-224">
              <h2 className="text-4xl font-bold mb-4" data-id="element-225">Pumpkin Spice Season</h2>
              <p className="text-xl mb-6" data-id="element-226">Limited Time Only</p>
              <div className="w-32 h-32 mx-auto bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-6" data-id="element-227">
                <span className="text-6xl" data-id="element-228">☕</span>
              </div>
              <p className="text-lg" data-id="element-229">Visit us today!</p>
            </div>
          </div>
        </motion.div>
      </div>
      <div className="w-96 bg-white dark:bg-gray-900 border-l border-gray-200 dark:border-gray-800 p-6 overflow-y-auto" data-id="element-230">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-231">
          Post Composer
        </h2>
        <div className="space-y-6" data-id="element-232">
          <div data-id="element-233">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-234">
              Template
            </label>
            <div className="grid grid-cols-2 gap-2" data-id="element-235">
              {templates.map((template, idx) => <button key={idx} onClick={() => setSelectedTemplate(idx)} className={`p-3 rounded-xl text-left transition-all ${selectedTemplate === idx ? 'bg-purple-100 dark:bg-purple-900/20 border-2 border-purple-600' : 'bg-gray-50 dark:bg-gray-800 border-2 border-transparent hover:border-gray-300 dark:hover:border-gray-700'}`} data-id="element-236">
                  <p className="font-medium text-sm text-gray-900 dark:text-white" data-id="element-237">
                    {template.name}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-238">
                    {template.size}
                  </p>
                </button>)}
            </div>
          </div>
          <div data-id="element-239">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-240">
              Caption
            </label>
            <textarea value={caption} onChange={e => setCaption(e.target.value)} rows={4} className="w-full px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500 outline-none resize-none" data-id="element-241" />
            <button className="mt-2 text-sm text-purple-600 hover:text-purple-700 font-medium flex items-center gap-1" data-id="element-242">
              <SparklesIcon className="w-4 h-4" data-id="element-243" />
              AI Enhance Caption
            </button>
          </div>
          <div data-id="element-244">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-245">
              Design Elements
            </label>
            <div className="space-y-2" data-id="element-246">
              <button className="w-full p-3 rounded-xl bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors flex items-center gap-3" data-id="element-247">
                <TypeIcon className="w-5 h-5 text-gray-600 dark:text-gray-400" data-id="element-248" />
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-249">
                  Add Text
                </span>
              </button>
              <button className="w-full p-3 rounded-xl bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors flex items-center gap-3" data-id="element-250">
                <ImageIcon className="w-5 h-5 text-gray-600 dark:text-gray-400" data-id="element-251" />
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-252">
                  Add Image
                </span>
              </button>
              <button className="w-full p-3 rounded-xl bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors flex items-center gap-3" data-id="element-253">
                <SparklesIcon className="w-5 h-5 text-gray-600 dark:text-gray-400" data-id="element-254" />
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-255">
                  Brand Elements
                </span>
              </button>
            </div>
          </div>
          <div data-id="element-256">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-257">
              Publish To
            </label>
            <div className="space-y-2" data-id="element-258">
              <label className="flex items-center gap-3 p-3 rounded-xl border border-gray-200 dark:border-gray-800 cursor-pointer hover:border-purple-300 dark:hover:border-purple-700 transition-colors" data-id="element-259">
                <input type="checkbox" defaultChecked className="w-4 h-4 text-purple-600 rounded" data-id="element-260" />
                <InstagramIcon className="w-5 h-5 text-pink-600" data-id="element-261" />
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-262">
                  Instagram
                </span>
              </label>
              <label className="flex items-center gap-3 p-3 rounded-xl border border-gray-200 dark:border-gray-800 cursor-pointer hover:border-purple-300 dark:hover:border-purple-700 transition-colors" data-id="element-263">
                <input type="checkbox" defaultChecked className="w-4 h-4 text-purple-600 rounded" data-id="element-264" />
                <FacebookIcon className="w-5 h-5 text-blue-600" data-id="element-265" />
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-266">
                  Facebook
                </span>
              </label>
            </div>
          </div>
          <div className="flex gap-2 pt-4" data-id="element-267">
            <button className="flex-1 px-4 py-3 rounded-xl bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white font-medium hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors flex items-center justify-center gap-2" data-id="element-268">
              <DownloadIcon className="w-5 h-5" data-id="element-269" />
              Download
            </button>
            <button className="flex-1 px-4 py-3 rounded-xl bg-purple-600 text-white font-medium hover:bg-purple-700 transition-colors" data-id="element-270">
              Publish Now
            </button>
          </div>
        </div>
      </div>
    </div>;
}